import { render, staticRenderFns } from "./WombatTable.vue?vue&type=template&id=331243a7&scoped=true"
import script from "./WombatTable.vue?vue&type=script&lang=js"
export * from "./WombatTable.vue?vue&type=script&lang=js"
import style0 from "./WombatTable.vue?vue&type=style&index=0&id=331243a7&prod&scoped=true&lang=scss"
import style1 from "./WombatTable.vue?vue&type=style&index=1&id=331243a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331243a7",
  null
  
)

export default component.exports